export enum CdfDataType {
  None = 'None',
  Alpha = 'Alpha',
  Numeric = 'Numeric',
  Date = 'Date',
  AlphaNumeric = 'AlphaNumeric'
}
